import type { EntityType } from 'types/entityType';

export const ENTITY_TYPE: EntityType = 'drone';

export const TEST_ID = 'droneMultiSelectPanelField';
